import { _AdvertiseImgIndividualBase } from './advertiseImgIndividualBase'

export class _AdvertiseImgIndividualSmall extends _AdvertiseImgIndividualBase {
  cssType: 'default' | 'small' = 'small'
  protected initPC(): this {
    this['--advertse-img-individual-width'] = '3.74rem'
    this['--advertse-img-individual-height'] = '1.46rem'

    return this
  }
  protected initH5(): this {
    this['--advertse-img-individual-width'] = '5.2rem'
    this['--advertse-img-individual-height'] = '2.04rem'
    return this
  }
}
